import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    globalScoreWrapper: {
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      globalScoreChart: {
        alignSelf: 'center',
        position: 'relative',
        marginTop: '10px',
        marginBottom: '5px'

      },
      globalScore: {
        fontFamily: 'Inter',
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: 'normal',
        color: theme.palette.black.dark,
        position: 'absolute',
        bottom: '10px',
        left: "0",
        right: "0",
        "margin-inline": "auto", 
        width: "fit-content;",
        '& .score': {
          fontSize: '34px',
          paddingRight: "4px"
        },
        '& .max-score': {
          opacity: 0.4,
        },
      },
      globalScoreDivider: {
        height: '1px',
        backgroundColor: theme.palette.grey.grey200,
        width: '90%',
        marginBottom: "10px"
      },
}))

export default useStyles;